// Push the Google Ads enhanced-conversion event after a signup.
//
// The SSR shell provides the event in a #conversion-tag-init JSON data island.
// It used to be a `<script>` whose body was built server-side by interpolating
// `JSON.stringify(auth.email)` into a template literal — see ConversionTagInit
// in @brave-new-world/shared for why that was unsafe as well as unchecked.
import { Islands } from "@brave-new-world/shared";
import { readIsland } from "../ui/islands";

/** `dataLayer` is created by the GTM snippet in Head.tsx. */
declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function initConversionTag(): void {
  const payload = readIsland(Islands.conversionTag);
  if (!payload) return;

  // GTM may not have initialised yet; it creates the array itself when it loads,
  // so seeding it here is the documented way to queue an early event.
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    event: payload.event,
    enhanced_conversion_data: { email: payload.email },
  });
}
